(function () {
  const roots = Array.from(document.querySelectorAll(".odyss-support-manual"));
  if (!roots.length) return;

const navLinks = Array.from(document.querySelectorAll(".odyss-support-manual .nav-link"));
const sections = Array.from(document.querySelectorAll(".odyss-support-manual [data-section]"));
const navSection = document.querySelector(".odyss-support-manual-nav-section");
const sideNav = navSection?.querySelector(".side-nav");
const footerSection = document.querySelector(".odyss-support-manual-footer-section");
const desktopQuery = window.matchMedia("(min-width: 981px)");

function linkHash(link) {
  var href = link.getAttribute("href") || "";
  var hashIndex = href.indexOf("#");
  return hashIndex >= 0 ? href.slice(hashIndex) : "";
}

function setActiveLink(id) {
  navLinks.forEach((link) => {
    link.classList.toggle("active", linkHash(link) === `#${id}`);
  });

  const activeSideLink = document.querySelector(".odyss-support-manual .side-nav .nav-link.active");
  if (activeSideLink) {
    const sideNav = activeSideLink.closest(".side-nav");
    if (sideNav) {
      const linkTop = activeSideLink.offsetTop;
      const linkBottom = linkTop + activeSideLink.offsetHeight;
      const viewTop = sideNav.scrollTop;
      const viewBottom = viewTop + sideNav.clientHeight;
      const edgeGap = 32;

      if (linkTop < viewTop + edgeGap) {
        sideNav.scrollTo({ top: Math.max(linkTop - edgeGap, 0), behavior: "auto" });
      } else if (linkBottom > viewBottom - edgeGap) {
        sideNav.scrollTo({ top: linkBottom - sideNav.clientHeight + edgeGap, behavior: "auto" });
      }
    }
  }

  const activeMobileLink = document.querySelector(".odyss-support-manual .mobile-jump .nav-link.active");
  if (activeMobileLink) {
    const mobileJump = activeMobileLink.closest(".mobile-jump");
    if (mobileJump) {
      mobileJump.scrollTo({
        left: activeMobileLink.offsetLeft - mobileJump.clientWidth / 2 + activeMobileLink.clientWidth / 2,
        behavior: "auto",
      });
    }
  }
}

function currentSectionId() {
  const readingLine = window.scrollY + Math.min(440, window.innerHeight * 0.48);
  let current = sections[0]?.id;

  sections.forEach((section) => {
    if (section.offsetTop <= readingLine) {
      current = section.id;
    }
  });

  return current;
}

let scrollTicking = false;

function updateNavFooterBoundary() {
  if (!navSection || !sideNav || !footerSection || !desktopQuery.matches) {
    navSection?.classList.remove("is-over-footer");
    return;
  }

  const navRect = sideNav.getBoundingClientRect();
  const footerRect = footerSection.getBoundingClientRect();
  const overlapsFooter = footerRect.top <= navRect.bottom + 24 && footerRect.bottom >= navRect.top;
  navSection.classList.toggle("is-over-footer", overlapsFooter);
}

function updateActiveFromScroll() {
  const id = currentSectionId();
  if (id) {
    setActiveLink(id);
  }
  updateNavFooterBoundary();
  scrollTicking = false;
}

window.addEventListener("scroll", () => {
  if (!scrollTicking) {
    window.requestAnimationFrame(updateActiveFromScroll);
    scrollTicking = true;
  }
});

window.addEventListener("load", updateActiveFromScroll);
window.addEventListener("resize", updateActiveFromScroll);
window.addEventListener("hashchange", () => {
  const id = window.location.hash.replace("#", "");
  if (id) {
    setActiveLink(id);
  }
});

navLinks.forEach((link) => {
  link.addEventListener("click", () => {
    const id = linkHash(link).replace("#", "");
    if (id) {
      setActiveLink(id);
    }
  });
});

})();
